module.exports = __webpack_public_path__ + "media/dàp-bêrn hĕe.0858b70a.mp3";